/* unplugin-vue-components disabled */import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'Overlay',
  props: {
    showOverlay: {
      type: Boolean
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var _toRefs = toRefs(props),
      showOverlay = _toRefs.showOverlay;
    return function (_ctx, _cache) {
      var _component_van_loading = _resolveComponent("van-loading");
      var _component_van_overlay = _resolveComponent("van-overlay");
      return _openBlock(), _createBlock(_component_van_overlay, {
        show: _unref(showOverlay),
        "z-index": "999999999",
        class: "customize-overlay"
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", {
            class: "wrapper",
            onClick: _cache[0] || (_cache[0] = _withModifiers(function () {}, ["stop"]))
          }, [_createVNode(_component_van_loading, {
            size: "80",
            color: "#0094ff"
          })])];
        }),
        _: 1
      }, 8, ["show"]);
    };
  }
});